/**
 * /faq — the questions people actually ask, with FAQPage structured data.
 *
 * The words live in src/content/faq.js and the layout lives in
 * src/components/Faq. Nothing here but the route's entry point, which is
 * the same shape every other page in this folder uses.
 *
 * See docs/aeo/AEO-LEDGER.md, task 10.
 */

import Faq from '../components/Faq';

const PageFaq = () => <Faq />;

export default PageFaq;
